import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=03cd322d&"
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports